import { create } from 'zustand';

interface SettingsSearchState {
  keyword: string;
  setKeyword: (keyword: string) => void;
  reset: () => void;
}

/**
 * 設定画面サイドバーの検索キーワードを保持するストア。
 * 各設定ページが個別に SettingsSidebar を描画するため、`/settings` 配下の画面遷移では
 * サイドバーが再マウントされる。キーワードをこのストアに持たせることで遷移をまたいで維持し、
 * `/settings` 以外の画面へ遷移した際に HeaderLayout 側で reset() する。
 */
export const useSettingsSearchStore = create<SettingsSearchState>((set) => ({
  keyword: '',
  setKeyword: (keyword) => set({ keyword }),
  reset: () => set({ keyword: '' }),
}));
